module.exports = __webpack_public_path__ + "img/icon-MA-Guest.0b29ee01.png";